import { Text, Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PropsWithChildren } from 'react';
import { CLICKABLE_PHOTO_CONTENT_CARDS } from '@/shared/static';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { CreateC49ClickablePhotoContentWrapperModel } from './C49ClickablePhotoContentWrapper.service';
import { translationClasses } from '@/shared/TranslationClasses';
import { C49ClickablePhotoContentWrapperProps } from './C49ClickablePhotoContentWrapper.types';
import { Container, ClickablePhotoContentCarousel } from '@ahc-digital/component-library';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { SwitchToPreviewMessage } from '@/shared/SwitchToPreviewMessage';

const Default = (props: C49ClickablePhotoContentWrapperProps) => {
  const phKey = CLICKABLE_PHOTO_CONTENT_CARDS + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const { renderRichText, renderLink } = useConditionalRendering();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (isEditing) {
    const Field = ({ children }: PropsWithChildren) => (
      <div style={{ display: 'grid', gap: '0.5rem' }}>{children}</div>
    );

    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <Container>
          <div style={{ display: 'grid', gap: '1.5rem' }}>
            <Field>
              <b>Headline:</b>
              <Text field={props?.fields?.Headline} />
            </Field>
            <Field>
              <b>Support copy:</b>
              {renderRichText(props?.fields?.SupportCopy)}
            </Field>
            {props?.rendering && <Placeholder name={phKey} rendering={props?.rendering} />}
            <Field>
              <b>Support copy bottom:</b>
              {renderRichText(props?.fields?.SupportCopyBottom)}
            </Field>
            <Field>
              <b>CTA:</b>
              {renderLink(props?.fields?.CTA)}
            </Field>
          </div>
        </Container>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <ClickablePhotoContentCarousel
      {...CreateC49ClickablePhotoContentWrapperModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C49ClickablePhotoContentWrapperProps>(Default);
